import { render, staticRenderFns } from "./ApprovalQuery.vue?vue&type=template&id=45742042"
import script from "./ApprovalQuery.vue?vue&type=script&lang=js"
export * from "./ApprovalQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports